import dayjs from "dayjs";

export function isLowPitchNumber(number: number): boolean {
	if (number % 1_000_000 === 0) {
		return true;
	}

	if (number % 1_000 === 0) {
		return false;
	}

	if (number % 100 === 0) {
		return true;
	}

	switch (number % 10) {
		case 3:
		case 6:
		case 8:
			return true;

		default:
	}

	switch ((number % 100) / 10) {
		case 2:
		case 3:
		case 6:
		case 8:
			return true;

		default:
			return false;
	}
}

export function currentYear(addAppendix: boolean = false): string {
	const year = dayjs().format("YYYY");

	if (addAppendix) {
		return `${year}-${isLowPitchNumber(Number(year)) ? "ban" : "ben"}`;
	}

	return year;
}
